var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 14C14.6716 14 14 14.6716 14 15.5V20.5C14 21.3281 14.6716 22 15.5 22H18.5C19.3281 22 20 21.3281 20 20.5V15.5C20 14.6716 19.3281 14 18.5 14H15.5ZM18.5 20.5H15.5V15.5H18.5V20.5ZM22 21.5C22 20.6719 22.6719 20 23.5 20H26.5C27.3281 20 28 20.6719 28 21.5V26.5C28 27.3281 27.3281 28 26.5 28H23.5C22.6719 28 22 27.3281 22 26.5V21.5ZM26.5 26.5H23.5V21.5H26.5V26.5ZM18.5 23C19.3281 23 20 23.6719 20 24.5V26.5C20 27.3281 19.3281 28 18.5 28H15.5C14.6716 28 14 27.3281 14 26.5V24.5C14 23.6719 14.6716 23 15.5 23H18.5ZM15.5 24.5H18.5V26.5H15.5V24.5ZM22 15.5C22 14.6716 22.6719 14 23.5 14H26.5C27.3281 14 28 14.6716 28 15.5V17.5C28 18.3281 27.3281 19 26.5 19H23.5C22.6719 19 22 18.3281 22 17.5V15.5ZM26.5 17.5H23.5V15.5H26.5V17.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7e940cd5497c4343d13a6aff4c3bd5a8.svg";
export { ForwardRef as ReactComponent };